module.exports = __webpack_public_path__ + "img/Melder.f2abd54b.svg";